<span class="dotted-text" [attr.data-test-id]="'table-date-' + rowIndex + '-' + cellIndex">
  {{ tableRowData[tableCellAttribute.key] | formatDate: 'date' }}
</span>
